import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.RateExperience = {
  displayName: 'RateExperience',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    if (Job.Data.closureSurvey.rating !== null && Job.Data.closureSurvey.rating < 3) {
      if (Job.Data.closureSurvey.selectedReasons.length === 0) {
        $(".reasons-error-message").removeClass('hidden')
      }
      else (
        onStepProgression()
      )
    }
    else {
      onStepProgression()
    }
  },

  component: React.createClass({
    getInitialState: function() {
      const closureSurvey = Job.Data.closureSurvey;

      return {
        rating: closureSurvey.rating,
        starClassDefault: "font-24 text-copy-0 p8 ",
        showReasons: false,
        showLeaveAComment: false
      }
    },

    handleLowRatingClick: function(e, value) {
      Job.Data.closureSurvey.rating = value
      this.setState({ showReasons: true, showLeaveAComment: true, rating: value })
    },

    handleRatingSubmit: function() {
      if (Job.Data.closureSurvey.value !== null && typeof Job.Data.closureSurvey.value !== 'undefined') {
        JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.SubmitFeedback)
      }
      else {
        JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.HowMuchDidYouPay)
      }
    },

    handleRatingBack: function() {
      JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.WhoDidTheJob)
    },

    handleHighRatingClick: function(e, value) {
      Job.Data.closureSurvey.rating = value
      Job.Data.closureSurvey.selectedReasons = []
      this.setState({ showReasons: false, showLeaveAComment: true, rating: value })
    },

    changeStarToFull: function($star) {
      $star.removeClass("ficon-star-empty")
           .addClass("ficon-star-full")
    },

    changeStarToEmpty: function($star) {
      $star.removeClass("ficon-star-full")
           .addClass("ficon-star-empty")
    },

    handleMouseHoverOnStarOne: function(e) {
      this.changeStarToFull($('#survey_feedback_rating_1'))
      this.changeStarToEmpty($('#survey_feedback_rating_2'))
      this.changeStarToEmpty($('#survey_feedback_rating_3'))
      this.changeStarToEmpty($('#survey_feedback_rating_4'))
      this.changeStarToEmpty($('#survey_feedback_rating_5'))
    },

    handleMouseOutOnStarOne: function(e) {
      this.changeStarToEmpty($('#survey_feedback_rating_1'))
    },

    handleMouseHoverOnStarTwo: function(e) {
      this.handleMouseHoverOnStarOne()
      this.changeStarToFull($('#survey_feedback_rating_2'))
    },

    handleMouseOutOnStarTwo: function(e) {
      this.handleMouseOutOnStarOne()
      this.changeStarToEmpty($('#survey_feedback_rating_2'))
    },

    handleMouseHoverOnStarThree: function(e) {
      this.handleMouseHoverOnStarTwo()
      this.changeStarToFull($('#survey_feedback_rating_3'))
    },

    handleMouseOutOnStarThree: function(e) {
      this.handleMouseOutOnStarTwo()
      this.changeStarToEmpty($('#survey_feedback_rating_3'))
    },

    handleMouseHoverOnStarFour: function(e) {
      this.handleMouseHoverOnStarThree()
      this.changeStarToFull($('#survey_feedback_rating_4'))
    },

    handleMouseOutOnStarFour: function(e) {
      this.handleMouseOutOnStarThree()
      this.changeStarToEmpty($('#survey_feedback_rating_4'))
    },

    handleMouseHoverOnStarFive: function(e) {
      this.handleMouseHoverOnStarFour()
      this.changeStarToFull($('#survey_feedback_rating_5'))
    },

    handleMouseOutOnStarFive: function(e) {
      this.handleMouseOutOnStarFour()
      this.changeStarToEmpty($('#survey_feedback_rating_5'))
    },

    handleMouseOutOnAllStars: function(e) {
      if (this.state.rating) {
        this.handleMouseHoverOnStarOne()
      }
      if (parseInt(this.state.rating) >= 2) {
        this.handleMouseHoverOnStarTwo()
      }
      if (parseInt(this.state.rating) >= 3) {
        this.handleMouseHoverOnStarThree()
      }
      if (parseInt(this.state.rating) >= 4) {
        this.handleMouseHoverOnStarFour()
      }
      if (parseInt(this.state.rating) === 5) {
        this.handleMouseHoverOnStarFive()
      }
    },

    handleCommentsOnChange: function(e) {
      Job.Data.closureSurvey.comments = e.target.value
    },

    handleFeedbackReasonsOnChange: function(e) {
      const reasons = Job.Data.closureSurvey.selectedReasons

      if (e.target.checked) {
        $(".reasons-error-message").addHidden()

        reasons.push({feedback_reason_id: e.target.value, selected: "true"})
      } else {
        let index = reasons.indexOf({feedback_reason_id: e.target.value, selected: "true"})
        reasons.splice(index, 1)
      }
    },

    render() {
      let label = Job.Data.closureSurvey.rating ? "Next" : "No thanks, I don't want to leave a rating yet"
      return (
        <div>
          <h3 className="mb15 mt20">Rate your experience with {Job.Data.closureSurvey.providerAccountName}</h3>
          <div className="form-group">
            <div className="col-xs-12 white-box bordered text-center p20 pt32 pb32 mb30" id="star-rating-input" onMouseOut={this.handleMouseOutOnAllStars}>
              <span className={this.state.starClassDefault + (this.state.rating ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_1"
                    onMouseOver={this.handleMouseHoverOnStarOne}
                    onMouseOut={this.handleMouseOutOnStarOne}
                    onClick={(e) => this.handleLowRatingClick(e, "1")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) >= 2) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_2"
                    onMouseOver={this.handleMouseHoverOnStarTwo}
                    onMouseOut={this.handleMouseOutOnStarTwo}
                    onClick={(e) => this.handleLowRatingClick(e, "2")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) >= 3) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_3"
                    onMouseOver={this.handleMouseHoverOnStarThree}
                    onMouseOut={this.handleMouseOutOnStarThree}
                    onClick={(e) => this.handleHighRatingClick(e, "3")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) >= 4) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_4"
                    onMouseOver={this.handleMouseHoverOnStarFour}
                    onMouseOut={this.handleMouseOutOnStarFour}
                    onClick={(e) => this.handleHighRatingClick(e, "4")}>
              </span>
              <span className={this.state.starClassDefault + ((parseInt(this.state.rating) === 5) ? "ficon-star-full" : "ficon-star-empty")}
                    id="survey_feedback_rating_5"
                    onMouseOver={this.handleMouseHoverOnStarFive}
                    onMouseOut={this.handleMouseOutOnStarFive}
                    onClick={(e) => this.handleHighRatingClick(e, "5")}>
              </span>
            </div>
            { (this.state.showLeaveAComment === true || this.state.rating) &&
              <div>
                <label className="mb5 mt20">Leave a comment (Optional)</label>
                <textarea
                  className="component-block mt15 p16 h120 form-control"
                  id="survey_feedback_comments"
                  name="survey_feedback_comments"
                  onChange={this.handleCommentsOnChange}
                />
              </div>
            }
            <div className= "pt30 pb30">
              <div className="reasons-error-message alert alert-danger hidden">
                Please select at least one to be published on Business Profile
              </div>

              <div className="row">
                <div className="col-xs-12 pb10">
                  <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main" style={{'whiteSpace': 'normal'}} onClick={this.handleRatingSubmit}>
                    {label}
                  </a>
                </div>
                <div className="col-xs-12">
                  <a href="#" id="modal-nav-one-button" className="btn btn-block btn-clear" style={{'whiteSpace': 'normal'}} onClick={this.handleRatingBack}>
                    Back
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      )
    }
  })
}

